
import React from "react";
import * as rb from "react-bootstrap";
import { useMessageModalContext } from "../MessageModal";

export const FatalModal = () => {
    const { hideModal, store } = useMessageModalContext();
    const { modalProps } = store || {};
    const { title, confirmBtn } = modalProps || {};

    const handleModalToggle = () => {
        hideModal();
    };

    return (
        <rb.Modal className={'dialog-modal'} show={true} centered onHide={handleModalToggle}>
            <rb.Modal.Header closeButton>
                <rb.Modal.Title>Header</rb.Modal.Title>
            </rb.Modal.Header>
            <rb.Modal.Body className={'pre-wrap'}>


                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim
                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                commodo consequat.Duis aute irure dolor in reprehenderit in voluptate
                velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                est laborum.

          </rb.Modal.Body>
            <rb.Modal.Footer>
                <rb.Button variant="primary btn-block" onClick={handleModalToggle} >
                    {confirmBtn || "Confirm button"}
                </rb.Button>
                < rb.Button variant="warning btn-block" onClick={handleModalToggle} >
                    Cancel
</rb.Button>
            </rb.Modal.Footer>
        </rb.Modal>
    );
};